import { combineReducers } from "redux";
import { accelerator, showAcceleratorUnusedCallout } from "./accelerator";
import { canToggleVisibility } from "./canToggleVisibility";
import { collaborators } from "./collaborators";
import { competitionsPaneInfo } from "./competitionsPaneInfo";
import { dataSourceReferences } from "./dataSourceReferences";
import { dataSourceRemoved } from "./dataSourceRemoved";
import { dataSources } from "./dataSources";
import { disableComments } from "./disableComments";
import { docker } from "./docker";
import { dockerImageTag } from "./dockerImageTag";
import { errors } from "./errors";
import { firebaseSessionId } from "./firebaseSessionId";
import { internet } from "./internet";
import { ipynb } from "./ipynb";
import { isPrivate } from "./isPrivate";
import { jupyterProxyUrl } from "./jupyterProxyUrl";
import { kernel } from "./kernel";
import { kernelIdPath } from "./kernelIdPath";
import { languageId } from "./languageId";
import { lastSetIpynbMs } from "./lastSetIpynbMs";
import { outputDataset } from "./outputDataset";
import { owner } from "./owner";
import { queuePosition } from "./queuePosition";
import { readerGroupId } from "./readerGroupId";
import { run } from "./run";
import { saveStatus } from "./saveStatus";
import { focusOnSchedule, schedule } from "./schedule";
import { sequence } from "./sequence";
import { showKernelDraftFailedSaveWarning } from "./showKernelDraftFailedSaveWarning";
import { showKernelForkedFromPaidTierWarning } from "./showKernelForkedFromPaidTierWarning";
import { slug } from "./slug";
import { startedCanceled } from "./startedCanceled";
import { tags } from "./tags";
import { title } from "./title";
import { unitName } from "./unitName";
import { workerPoolName } from "./workerPoolName";
import { writerGroupId } from "./writerGroupId";

export const notebook = combineReducers({
  kernel,
  tags,
  run,
  startedCanceled,
  title,
  slug,
  languageId,
  internet,
  accelerator,
  showAcceleratorUnusedCallout,
  showKernelForkedFromPaidTierWarning,
  showKernelDraftFailedSaveWarning,
  collaborators,
  owner,
  saveStatus,
  jupyterProxyUrl,
  sequence,
  disableComments,
  isPrivate,
  canToggleVisibility,
  ipynb,
  lastSetIpynbMs,
  dataSources,
  dataSourceReferences,
  dataSourceRemoved,
  docker,
  firebaseSessionId,
  unitName,
  queuePosition,
  schedule,
  kernelIdPath,
  dockerImageTag,
  workerPoolName,
  errors,
  readerGroupId,
  writerGroupId,
  competitionsPaneInfo,
  outputDataset,
  focusOnSchedule,
});
